// Copyright © Veeam Software Group GmbH

import React from 'react';
import { BodyLayout, DataGrid } from '@veeam/components';

import { useResources } from 'infrastructure/resources';
import { useRestoreBucketModel } from './hooks/useModel';
import { useRestoreSessionRouting } from '../../infrastructure/routing';
import { useColumns } from './hooks/useColumns';
import { useToolbar } from './hooks/useToolbar';

export const RestoreListPage: React.FC = () => {
    const resources = useResources().features.RecoveryList;
    const model = useRestoreBucketModel();
    const routing = useRestoreSessionRouting();
    const columns = useColumns(resources, routing);
    const toolbar = useToolbar(resources, model);

    return (
        <BodyLayout>
            <DataGrid
                model={model}
                columns={columns}
                toolbar={toolbar}
                config={{
                    canResizeColumns: true,
                    columnsToggleable: true,
                    selection: {
                        multi: true,
                        withCheckbox: true,
                    },
                }}
            />
        </BodyLayout>
    );
};
